import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getAllDrivers,
  getOrdersInfoByDrivers,
} from "../../services/driversService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getDrivers(restaurant) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(getAllDrivers, token, restaurant.restaurantId);
    if (response[0] === 200) {
      yield put({
        type: actions.GET_DRIVERS_SUCCESS,
        drivers: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getOrderInfoByDrivers({
  driversIds,
  startDate,
  endDate,
  selectedRestaurant,
}) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      getOrdersInfoByDrivers,
      token,
      driversIds,
      startDate,
      endDate,
      selectedRestaurant
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_ORDERS_INFO_SUCCESS,
        ordersInfo: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_DRIVERS_REQUEST, getDrivers),
    yield takeEvery(actions.GET_ORDERS_INFO_REQUEST, getOrderInfoByDrivers),
  ]);
}
